module.exports = __webpack_public_path__ + "img/IMG_1899_L_Black_MockedUp.ebd6380a.jpg";